//
// Grouping.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "../common/BIRDDataType";
import "./GroupingVariable";
import "./Group";
import "./Other";

var Grouping = createModule("BIRD::Grouping", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        groupingVariables: [1],
        other: 1,
        name: 7,
        outputType: 4,
        groups: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Grouping;
